import React, { useEffect, useState } from "react";
import {
  Col,
  Drawer,
  // Flex,
  FloatButton,
  Image,
  Layout,
  Modal,
  Row,
  //   theme,
} from "antd";
import { CommentOutlined } from "@ant-design/icons";
import Logo from "../../assets/images/main-logo.png";
// import Logo from "../../assets/images/sidebar-logo.png";
import "./index.css";
import Login from "../Auth";
import Register from "../Auth/register";
import GstBills from "./gstBills";
import Inventory from "./inventory";
import PaymentReminders from "./payment-reminders";
import Invoice from "./hero";
import { Link } from "react-router-dom";

const { Header, Content } = Layout;
// const { Header, Content, Footer } = Layout;

// const items = menuItems.map((_, index) => ({
//   key: String(index + 1),
//   label: _.label,
// }));

const Landing = () => {
  //   const {
  //     token: { colorBgContainer, borderRadiusLG },
  //   } = theme.useToken();

  //   const [open, setOpen] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [chatModal, setChatModal] = useState(false);
  const [register, setRegister] = useState(false);
  const [signIn, setSignIn] = useState(false);
  const closeDrawer = () => setShowDrawer(false);
  const closeChat = () => setChatModal(false);

  const onSignin = (values) => {
    setSignIn(values);
    setRegister(false);
  };
  const onRegister = (values) => {
    setRegister(values);
    setSignIn(false);
  };

  useEffect(() => {
    if (signIn) {
      setShowDrawer(true);
    }
  }, [signIn]);

  console.log(signIn, register, "signIn");
  console.log(window, "signIn");

  const menuItems = [
    {
      label: "Pricing",
      value: "pricing",
      path: "/pricing",
    },
    {
      label: "About Us",
      value: "aboutUs",
      path: "/about-us",
    },
    {
      label: "Desktop",
      value: "desktop",
      path: "/desktop",
    },
    {
      label: "Careers",
      value: "careers",
      path: "/careers",
    },
    {
      label: "Partner with us",
      value: "partner",
      path: "/partner",
    },
    {
      label: "Create Account",
      value: "createAccount",
      path: "/create-account",
    },
  ];

  return (
    <Layout className="landing landing-main-card">
      <Header className="landing-header lg:h-[67px] xl:h-[67px] xxl:h-[67px] md:h-[95px] sm:h-[264px] font-poppins">
        {/* <Col className="mt-2"> */}
        <Row>
          <Col
            md={24}
            lg={8}
            xl={8}
            xxl={8}
            sm={24}
            className="mt-[-8px]"
          >
            <Link to="/">
              <Image preview={false} src={Logo} width={150} />
            </Link>
          </Col>
          <Col
            md={24}
            lg={16}
            xl={16}
            xxl={16}
            sm={24}
            xs={24}
            className="md:mt-[-60px] sm:mt-[-60px] lg:mt-0 xl:mt-0 xxl:mt-0"
          >
            <Row
              // gap={"small"}
              // justify="space-evenly"
              // dir={'sm:col xs:col row'}
              className="flex flex-col justify-items-center md:flex-row lg:flex-row xl:flex-row xxl:flex-row md:justify-evenly lg:justify-evenly xl:justify-evenly xxl:justify-evenly"
            >
              {menuItems.map((menu, index) => {
                return (
                  <ul key={index} className="sm:mb-[-30px] xs:mb-[-30px]">
                    <Link
                      to={{
                        pathname: menu.path,
                      }}
                      className="text-[#9d9d9d] text-[14px] md:text-[16px] xxl:text-[16px] xl:text-[16px] lg:text-[16px] font-medium font-sans cursor-pointer menu-items"
                      onClick={() => {
                        if (menu.label === "Login") {
                          setShowDrawer(true);
                        }
                      }}
                    >
                      {menu.label}
                    </Link>
                  </ul>
                );
              })}
            </Row>
          </Col>
        </Row>
        {/* </Col> */}
      </Header>
      <Content
        style={{
          padding: "3px",
          paddingLeft: "110px",
          zIndex: 1,
          // marginTop: "100px",
        }}
        // className="landing-main-card w-[100%]"
      >
        <Drawer
          destroyOnClose
          open={showDrawer}
          title={register === true ? "Create Account" : "Login"}
          onClose={closeDrawer}
        >
          {register === true && !signIn ? (
            <Register onSignin={onSignin} />
          ) : (
            <Login onRegister={onRegister} />
          )}
        </Drawer>
        {/* Billing Software */}
        <Row className="mb-10">
          <Invoice />
        </Row>
        <Row className="mb-10">
          <GstBills />
        </Row>
        <Row>
          <Inventory />
        </Row>
        <Row>
          <PaymentReminders />
        </Row>

        <Modal
          open={chatModal}
          closeIcon={true}
          title="Chat"
          destroyOnClose
          onCancel={closeChat}
        >
          Content
        </Modal>
        {/* <FloatButton.Group
          open={chatModal}
          trigger="click"
          style={{
            right: 24,
          }}
          // icon={<CustomerServiceOutlined />}
        >
          <FloatButton />
          <FloatButton icon={<CommentOutlined />} />
        </FloatButton.Group> */}
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-3px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Content>
      {/* <Footer
        style={{
          textAlign: "center",
        }}
      >
        MBook ©{new Date().getFullYear()} Created by Mequals Technologies
      </Footer> */}
    </Layout>
  );
};
export default Landing;
